import { Injectable }  from '@angular/core';
import { Http }  from '@angular/http';

import { CookieUtils } from '../shared/cookieutils';

import {BaseService} from './base.service';
import {BaseServiceExceptionHandler} from './base-service-exception-handler';

@Injectable()
export class GetGameSummariesForSeasonService extends BaseService {

	constructor($http: Http, $cookies: CookieUtils, BaseServiceExceptionHandler: BaseServiceExceptionHandler) {
		super($http, $cookies, BaseServiceExceptionHandler);
	}

    public get(requestObj: any) {
        let urlStr: string = 'league/' + requestObj.leagueId + '/season/' + requestObj.seasonId + '/game/list?';
        if (requestObj.startDate) {
            urlStr += 'startdate=' + requestObj.startDate + "&";
        }
        if (requestObj.endDate) {
            urlStr += 'enddate=' + requestObj.endDate + "&";
        }
        if (requestObj.teamId) {
            urlStr += 'teamid=' + requestObj.teamId + "&";
        }
        if (requestObj.playerId) {
            urlStr += 'playerid=' + requestObj.playerId + "&";
        }
        if (requestObj.status && requestObj.status.length > 0) {
            var statusStr = "";
            requestObj.status.forEach(function(statusVal) {
                if (statusStr.length > 0) {
                    statusStr += ",";
                }
                statusStr += statusVal;
            });
            urlStr += 'status=' + statusStr + "&";
        }
        if (requestObj.offset) {
            urlStr += 'offset=' + requestObj.offset + "&";
        }
        if (requestObj.limit) {
            urlStr += 'limit=' + requestObj.limit + "&";
        }

	    return this.sendRequest('GET',
                                urlStr,
                         	    null,
                                null,
                                false);
    }

}
